// src/api/userApi.js

import axios from '../axios';

const userApi = {
    changePassword: (data) => axios.post('/User/change-password', data),
    changeUserName: (data) => axios.post('/User/change-username', data),
    changeMobile: (data) => axios.post('/User/change-mobile', data),
    adminResetPassword: (data) => axios.post('/User/admin-reset-password', data),
    getAllUsers: (companyId) => axios.get(`/User/AllUser/${companyId}`),

    // استعادة كلمة المرور عبر البريد
    forgotPassword: (data) => axios.post('/User/forgot-password', data),
    validateResetToken: (token) => axios.get('/User/reset-password/validate', { params: { token } }),
    resetPassword: (data) => axios.post('/User/reset-password', data),
};

export default userApi;